import TomSelect from "tom-select/base";

class JsSelectService {
    constructor() {
        document.addEventListener("DOMContentLoaded", () => {
            document.querySelectorAll(".js-select").forEach((el) => {
                const selectEl = el;

                const variant = {
                    control: ["rounded-lg", "border", "border-ts-black", "py-1", "relative"],
                    dropdown:
                        "border border-ts-black rounded-b-lg shadow-lg mt-0 !bg-white overflow-hidden z-20",
                    option: "text-sm cursor-pointer !bg-transparent hover:!bg-ts-light",
                    item: "ts-item text-black text-sm",
                };

                const isMulti = el.multiple;

                const settings = {
                    create: false,
                    highlight: false,
                    openOnFocus: true,
                    closeAfterSelect: !isMulti,

                    onInitialize: function () {
                        this.control.classList.add(...variant.control);

                        if (this.control_input) {
                            this.control_input.readOnly = true;
                            this.control_input.classList.add("cursor-pointer");

                            const placeholder =
                                selectEl.dataset.placeholder ||
                                selectEl.getAttribute("placeholder") ||
                                (
                                    selectEl.querySelector('option[value=""]')?.textContent || ""
                                ).trim();

                            this._placeholder = placeholder;

                            if (placeholder) {
                                this.control_input.placeholder = placeholder;
                            }
                        }

                        const chevron = document.createElement("span");
                        chevron.innerHTML = `
                            <svg xmlns="http://www.w3.org/2000/svg"
                                class="chevron w-4 h-4 text-ts-black pointer-events-none transition-transform duration-200"
                                fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                    d="M19 9l-7 7-7-7" />
                            </svg>
                        `;

                        chevron.classList.add(
                            "absolute",
                            "right-3",
                            "top-1/2",
                            "-translate-y-1/2",
                            "pointer-events-none"
                        );

                        this.control.appendChild(chevron);
                        this._chevron = chevron.querySelector("svg");
                    },

                    onDropdownOpen: function () {
                        this.control.classList.remove("rounded-xl");
                        this.control.classList.add("rounded-t-xl", "rounded-b-none");

                        if (this._chevron) {
                            this._chevron.classList.add("rotate-180");
                        }
                    },

                    onDropdownClose: function () {
                        this.control.classList.remove("rounded-t-xl", "rounded-b-none");
                        this.control.classList.add("rounded-xl");

                        if (this._chevron) {
                            this._chevron.classList.remove("rotate-180");
                        }
                    },

                    render: {
                        dropdown: () => `<div class="${variant.dropdown}"></div>`,
                        item: (data, escape) => `<div class="${variant.item}">${escape(data.text)}</div>`,
                        option: (data, escape) =>
                            `<div class="${variant.option}">${escape(data.text)}</div>`,
                    },
                };

                new TomSelect(el, settings);
            });
        });
    }
}

export default JsSelectService;
